export function sortByString(list, key) {
  if (!list.length || !key)  return [];

  return list.sort((a, b) => a[key]?.localeCompare(b[key]));
}

export function sortByNumber(list, key) {
  if (!list.length || !key)  return [];

  return list.sort((a, b) => a[key] - b[key]);
}

export function cleanOptionForServer(option) {
  return { 
    id: option.id,
    requestId: option.requestId,
    supplierId: option.supplierId,
    price: option.price,
    quantity: option.quantity,
    unitId: option.unitId,
    paymentMethodId: option.paymentMethodId,
    eta: option.eta,
    note: option.note
  }
}